import { render } from "./FindMentorPage.vue?vue&type=template&id=7025f6b8&scoped=true"
import script from "./FindMentorPage.vue?vue&type=script&lang=js"
export * from "./FindMentorPage.vue?vue&type=script&lang=js"

import "./FindMentorPage.vue?vue&type=style&index=0&id=7025f6b8&scoped=true&lang=css"

import exportComponent from "/root/mentoringplatform-acm/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7025f6b8"]])

export default __exports__